<script>
import { mapState } from 'vuex'
import date from 'locutus/php/datetime/date'
import defaults from 'lodash/defaults'
import {
  fetchMerchant,
  createMerchant,
  updateMerchant,
  fetchFeesets,
} from '@apis/admin/pg'
import fromPairs from 'lodash/fromPairs'
import find from 'lodash/find'

export default {
  props: {
    merchant_seq: {
      type: [Number, String],
      default: null,
    },
  },
  data() {
    return {
      feesets: [],
      params: {},
      loading: false,
    }
  },
  computed: {
    ...mapState('common', {
      constants: (state) => state.constants,
    }),
    c_default_feeset_info() {
      return find(this.feesets, { is_default: 'Y' })
    },
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      this.loading = true
      this.loadFeesets()
        .then(() => Promise.all([this.loadMerchant()]))
        .catch((e) => this.$toasted.error(e.message))
        .finally(() => {
          this.loading = false
        })
    },
    async loadFeesets() {
      const { data } = await fetchFeesets()

      this.feesets = data
    },
    async loadMerchant() {
      const { merchant_info } = await fetchMerchant(
        this.params.seq || this.merchant_seq
      )
      this.params = defaults(merchant_info, {
        seq: null,
        feeset_seq: 0,
        brokerage_seq: 0,
        brokerage_identification_code: '',
        brokerage_: 0,
        merchant_name: '',
        merchant_id: '',
        api_signature: '',
        status: 'PENDING',
      })

      if (!find(this.feesets, { seq: this.params.feeset_seq })) {
        this.params.feeset_seq = 0
      }
    },
    handleSubmit() {
      const createOrUpdate = this.params.seq ? updateMerchant : createMerchant
      const confirm_message = this.params.seq
        ? this.$t('admin.msg_save')
        : this.$t('admin.msg_merchant')
      const success_message = this.params.seq
        ? this.$t('admin.msg_merchant_modify')
        : this.$t('admin.msg_merchant_open')

      this.loading = true
      this.$confirm(confirm_message, this.$t('admin.modal_confirm'))
        .then(() => createOrUpdate(this.params))
        .then(({ seq }) => this.$emit('submit', seq))
        .then(() => this.$toasted.success(success_message))
        .catch((e) => (e ? this.$toasted.error(e.message) : null))
        .finally(() => {
          this.loading = false
        })
    },
    date,
    fromPairs,
  },
}
</script>

<template>
  <form
    v-loading="loading"
    action="./"
    method="get"
    @submit.prevent="handleSubmit"
  >
    <table cellspacing="0" cellpadding="0" :class="$style.rowTable">
      <colgroup>
        <col width="20%" />
        <col width="30%" />
        <col width="20%" />
        <col width="30%" />
      </colgroup>
      <tbody>
        <tr>
          <th scope="row"
            ><div>{{ $t('pg_merchant_info.store_id') }}</div></th
          >
          <td>
            <template v-if="params.seq">{{ params.merchant_id }}</template>
            <input
              v-else
              v-model="params.merchant_id"
              type="text"
              :class="[$style.inputTypeText, $style.w120]"
            />
          </td>
          <th scope="row"
            ><div>{{ $t('pg_merchant_info.store_unique_number') }}</div></th
          >
          <td>{{ params.seq || $t('admin.auto') }}</td>
        </tr>
        <tr>
          <th scope="row"
            ><div>{{ $t('pg_merchant_info.store_name') }}</div></th
          >
          <td
            ><input
              v-model="params.merchant_name"
              type="text"
              :class="[$style.inputTypeText, $style.fullWidth]"
          /></td>
          <th scope="row"
            ><div>{{ $t('wallet.regdate') }}</div></th
          >
          <td>{{
            params.seq
              ? date('Y-m-d H:i:s', new Date(params.regdate))
              : $t('wallet.before_regdate')
          }}</td>
        </tr>
        <tr>
          <th scope="row"
            ><div>{{ $t('pg_merchant_info.application_fee') }}</div></th
          >
          <td>
            <select v-model="params.feeset_seq">
              <option :value="0" :class="[$style.fsI]"
                >{{ $t('pg_merchant_info.follow_defaul') }} ➜
                {{
                  c_default_feeset_info
                    ? c_default_feeset_info.title
                    : $t('pg_merchant_info.no_default')
                }}</option
              >
              <option v-for="val in feesets" :key="val.seq" :value="val.seq">{{
                val.title
              }}</option>
            </select>
          </td>
          <th scope="row"
            ><div>{{ $t('admin.status') }}</div></th
          >
          <td>{{ fromPairs(constants.pg.merchant.status)[params.status] }}</td>
        </tr>
        <tr>
          <th scope="row"
            ><div>{{ '마스터' }}</div></th
          >
          <td colspan="3"
            ><input
              v-model="params.brokerage_identification_code"
              type="text"
              :class="[$style.inputTypeText, $style.w120]"
          /></td>
        </tr>
        <tr>
          <th scope="row"
            ><div>{{ $t('pg_merchant_info.store_signature_key') }}</div></th
          >
          <td colspan="3">{{
            params.seq
              ? params.api_signature
              : $t('pg_merchant_info.automatic_generation')
          }}</td>
        </tr>
        <tr>
          <th colspan="4" :class="$style.button">
            <span :class="[$style.button, $style.black]"
              ><input
                type="submit"
                :value="params.seq ? $t('admin.save') : $t('admin.enroll')"
            /></span>
          </th>
        </tr>
      </tbody>
    </table>
  </form>
</template>

<style lang="scss" module>
@import '@src/design/default.scss';
@import '@src/design/admin.scss';
@import '@src/design/font.scss';
@import '@src/design/button.scss';
</style>
